// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ContentFooter_mainWrapper__3-Ncs","copyrightLine":"ContentFooter_copyrightLine__MfBnK","rowLink":"ContentFooter_rowLink__PeU0U"};